import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type FacilityWorkflowsFetchFailedAction = {
	type: 'FACILITY_WORKFLOWS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): FacilityWorkflowsFetchFailedAction => ({
	type: 'FACILITY_WORKFLOWS_FETCH_FAILED',
	payload,
});
